import { StyleType } from '@wix/editor-platform-ooi-metadata-resolver';
import { StyleParamType, createStylesParams, type IStyleParam } from '@wix/tpa-settings';
import { RssWidgetIconType } from '@app/common/settings-components/types';
import type { GetIStylesParams } from '@app/common/style-params';

const STYLE_PARAMS = {
  'widget-iconColor': {
    type: StyleParamType.Color,
    metadata: {
      type: StyleType.color,
      defaultValue: { type: 'static', preset: 'rgb(255,255,255)', opacity: 1 },
    },
    getDefaultValue: () => ({ value: 'rgb(255,255,255)', name: null, opacity: 1 }),
  },
  'widget-iconBackgroundColor': {
    type: StyleParamType.Color,
    metadata: {
      type: StyleType.color,
      defaultValue: { type: 'static', preset: 'rgb(250,173,77)', opacity: 1 },
    },
    getDefaultValue: () => ({ value: 'rgb(250,173,77)', name: null, opacity: 1 }),
  },
  'widget-iconColorNoBackground': {
    type: StyleParamType.Color,
    metadata: {
      type: StyleType.color,
      defaultValue: { type: 'static', preset: 'rgb(250,173,77)', opacity: 1 },
    },
    getDefaultValue: () => ({ value: 'rgb(250,173,77)', name: null, opacity: 1 }),
  },
  'widget-iconBackgroundType': {
    type: StyleParamType.Number,
    metadata: {
      type: StyleType.UNKNOWN_CssPropertyType,
      defaultValue: { type: 'static', value: RssWidgetIconType.Square },
    },
    getDefaultValue: () => RssWidgetIconType.Square,
  },
} as const satisfies {
  [key: string]: Omit<IStyleParam, 'name'>;
};

export type IStylesParams = GetIStylesParams<typeof STYLE_PARAMS>;

export default createStylesParams<IStylesParams>(STYLE_PARAMS);
